import { getGoogleApiKey } from './utils';

export const geocode = (query: string): Promise<google.maps.GeocoderResponse> => {
    const googleApiKey = getGoogleApiKey();
    return fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${query}&key=${googleApiKey}`)
        .then((resp) => resp.json())
        .then((obj) => obj as google.maps.GeocoderResponse);
};
